// Buy 1 Get 1: keeps one free line per eligible variant whose quantity matches the paid quantity.
// Pricing comes from Shopify Buy X Get Y discounts. If Shopify does not price the free units at
// zero (discount not active), the free lines are removed so shoppers are never charged for them.
(function () {
  if (window.__dtBogoCartLoaded) return;
  window.__dtBogoCartLoaded = true;

  var BOGO_PROPERTY = '_dt_bogo_for';
  var INACTIVE_RETRY_MS = 10 * 60 * 1000;
  var config;
  try {
    config = JSON.parse(document.getElementById('dt-bogo-config').textContent);
  } catch (error) {
    console.warn('[BOGO] Offer config is missing or invalid.', error);
    return;
  }
  var eligibleProductIds = new Set((config.productIds || []).concat(config.salesOnlyProductIds || []).map(String));
  var eligibleVariantIds = new Set((config.variantIds || []).concat(config.salesOnlyVariantIds || []).map(String));
  // Products also sold in normal collections: their free unit is only earned by adds made on the sales page,
  // which carry SOURCE_PROPERTY on the paid line.
  var SOURCE_PROPERTY = '_dt_bogo_source';
  var salesOnlyProductIds = new Set((config.salesOnlyProductIds || []).map(String));
  var salesOnlyVariantIds = new Set((config.salesOnlyVariantIds || []).map(String));
  var variantStock = config.stock || {};
  var BADGE_LABEL = config.badgeLabel || 'Buy 1 Get 1 Free';
  // Spare units required before the free unit is added in the same request as the paid one.
  // Stock on the page can be a little stale, and a failed combined request would also drop the paid item.
  var INSTANT_STOCK_MARGIN = 3;
  if (!eligibleProductIds.size) return;

  var running = null;
  var rerunRequested = false;
  var inactiveUntil = 0;
  // Variant ID -> paid quantity at the time its free unit could not be added (not enough stock).
  // Not retried until the paid quantity changes, so a stock limit never loops cart requests.
  var stockLimited = new Map();

  function isFreeLine(line) {
    return Boolean(line && line.properties && line.properties[BOGO_PROPERTY]);
  }

  function isPaidLine(line) {
    var properties = line.properties || {};
    if (isFreeLine(line) || properties._dt_retention_gift || properties._dt_diwali_gift) return false;
    if (salesOnlyProductIds.has(String(line.product_id))) return Boolean(properties[SOURCE_PROPERTY]);
    return eligibleProductIds.has(String(line.product_id));
  }

  function isSalesPageAdd(form) {
    return Boolean(form && form.closest && form.closest('.dt-wholesale.is-bogo'));
  }

  function cleanTitle(title) {
    return String(title || '').replace(/ - FS$/, '').split(' | ')[0].replace(/\s*\([^)]*\)/g, '').trim();
  }

  function groupByVariant(cart) {
    var groups = new Map();
    cart.items.forEach(function (line) {
      var free = isFreeLine(line);
      if (!free && !isPaidLine(line)) return;
      var variantId = String(line.variant_id);
      var group = groups.get(variantId) || { paidQuantity: 0, freeQuantity: 0, freeLines: [], lines: [], label: '' };
      if (free) {
        group.freeQuantity += Number(line.quantity) || 0;
        group.freeLines.push(line);
      } else {
        group.paidQuantity += Number(line.quantity) || 0;
        group.label = cleanTitle(line.product_title) + (line.variant_title ? ' (' + line.variant_title + ')' : '');
      }
      group.lines.push(line);
      groups.set(variantId, group);
    });
    return groups;
  }

  // Shopify can split one line into several when a discount covers only some units,
  // so compare total quantities per variant instead of individual lines.
  function planChanges(cart, offerActive) {
    var updates = {};
    var additions = [];
    var groups = groupByVariant(cart);
    stockLimited.forEach(function (paidQuantity, variantId) {
      var group = groups.get(variantId);
      if (!group || group.paidQuantity !== paidQuantity) stockLimited.delete(variantId);
    });
    groups.forEach(function (group, variantId) {
      var wanted = offerActive ? group.paidQuantity : 0;
      var difference = wanted - group.freeQuantity;
      if (difference === 0) return;
      if (difference > 0) {
        if (stockLimited.has(variantId)) return;
        // Adding with the same properties tops up an existing free line instead of creating a new one.
        var properties = {};
        properties[BOGO_PROPERTY] = variantId;
        additions.push({
          item: { id: Number(variantId), quantity: difference, properties: properties },
          paidQuantity: group.paidQuantity
        });
      } else {
        var excess = -difference;
        group.freeLines.slice().reverse().forEach(function (line) {
          if (!excess) return;
          var removed = Math.min(excess, Number(line.quantity));
          updates[line.key] = Number(line.quantity) - removed;
          excess -= removed;
        });
      }
    });
    return { updates: updates, additions: additions };
  }

  // True when every variant with free units is discounted by at least the value of those units.
  function freeUnitsArePriced(cart) {
    var priced = true;
    groupByVariant(cart).forEach(function (group, variantId) {
      if (!group.freeQuantity) return;
      var unitPrice = Number(group.freeLines[0].original_price) || 0;
      // Shopify may put the free price on any unit of the variant, including a line added outside the
      // sales page, so count every line of this variant, not only the lines that earn a free unit.
      var variantLines = cart.items.filter(function (line) { return String(line.variant_id) === variantId; });
      var discount = variantLines.reduce(function (total, line) {
        return total + (Number(line.original_line_price) || 0) - (Number(line.final_line_price) || 0);
      }, 0);
      if (discount < group.freeQuantity * unitPrice - variantLines.length) priced = false;
    });
    return priced;
  }

  async function readCart() {
    var response = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Unable to read cart.');
    return response.json();
  }

  async function postJson(url, body) {
    var response = await fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    return response;
  }

  async function applyChanges(changes) {
    if (Object.keys(changes.updates).length) {
      var updateResponse = await postJson('/cart/update.js', { updates: changes.updates });
      if (!updateResponse.ok) throw new Error('Unable to update Buy 1 Get 1 items.');
    }
    if (!changes.additions.length) return;
    var addResponse = await postJson('/cart/add.js', { items: changes.additions.map(function (addition) { return addition.item; }) });
    if (addResponse.ok) return;
    // Retry one by one so a stock limit on one variant does not block the others,
    // and fall back to a single free unit when the full quantity is not in stock.
    for (var i = 0; i < changes.additions.length; i += 1) {
      var addition = changes.additions[i];
      var variantId = String(addition.item.id);
      var response = await postJson('/cart/add.js', { items: [addition.item] });
      if (!response.ok && addition.item.quantity > 1) {
        response = await postJson('/cart/add.js', { items: [Object.assign({}, addition.item, { quantity: 1 })] });
      }
      if (!response.ok) stockLimited.set(variantId, addition.paidQuantity);
      if (response.status === 429) throw new Error('Cart is rate limited.');
    }
  }

  function cartSignature(cart) {
    return cart.items.map(function (line) { return line.key + ':' + line.quantity + ':' + line.final_line_price; }).join('|');
  }

  function stockNotice(cart) {
    var groups = groupByVariant(cart);
    var labels = [];
    stockLimited.forEach(function (paidQuantity, variantId) {
      var group = groups.get(variantId);
      if (group && group.freeQuantity < group.paidQuantity && group.label) labels.push(group.label);
    });
    if (!labels.length) return '';
    return 'Not enough stock for the free ' + labels.join(', ') + '. Try another colour to get Buy 1 Get 1.';
  }

  function showNotice(message) {
    document.querySelectorAll('.dt-bogo-notice').forEach(function (notice) { notice.remove(); });
    if (!message) return;
    document.querySelectorAll('#CartDrawer-CartItems, cart-items .cart-items, .cart__items').forEach(function (container) {
      var notice = document.createElement('p');
      notice.className = 'dt-bogo-notice';
      notice.setAttribute('role', 'status');
      notice.textContent = message;
      container.prepend(notice);
    });
  }

  async function refreshCartUi(cart) {
    if (window.CartController) {
      await window.CartController.refreshCart();
      window.CartController.updateCartCount();
      await Promise.all([
        window.CartController.refreshCartDrawerHTML({ refreshRecommendations: false }),
        window.CartController.refreshCartPageHTML()
      ]);
    }
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
  }

  async function syncPendingCartEdits() {
    var controller = window.CartController;
    if (!controller) return;
    if (controller.pendingRemovalKeys?.size || controller.pendingRemovalPromise) {
      if (!(await controller.flushPendingRemovals())) throw new Error('Unable to sync product removal.');
    }
    if (controller.pendingQuantityUpdates?.size || controller.pendingQuantityPromise) {
      if (!(await controller.flushQuantityUpdates())) throw new Error('Unable to sync quantity changes.');
    }
    // Instant adds are queued briefly before being sent; wait so the cart read below includes them.
    if (controller.pendingAddQueue?.length || controller.pendingAddPromise) {
      if (!(await controller.flushPendingAdds())) throw new Error('Unable to sync added items.');
    }
  }

  // The free unit to send alongside an add, or null when it should be left to reconcile().
  function instantFreeUnit(variantId, quantity, properties) {
    var id = String(variantId);
    if (!eligibleVariantIds.has(id) || (properties && properties[BOGO_PROPERTY])) return null;
    if (Date.now() < inactiveUntil || stockLimited.has(id)) return null;
    if (Object.prototype.hasOwnProperty.call(variantStock, id)) {
      var inCart = ((window.CartController && window.CartController.cart && window.CartController.cart.items) || [])
        .filter(function (line) { return String(line.variant_id) === id; })
        .reduce(function (total, line) { return total + (Number(line.quantity) || 0); }, 0);
      if (inCart + quantity * 2 + INSTANT_STOCK_MARGIN > Number(variantStock[id])) return null;
    }
    var freeProperties = {};
    freeProperties[BOGO_PROPERTY] = id;
    return { id: Number(variantId), quantity: quantity, properties: freeProperties };
  }

  // Restyles the instant free row to match the final cart row: FREE price, badge, no stepper.
  function styleInstantFreeRows(variantId) {
    document.querySelectorAll('cart-drawer tr.cart-item--optimistic[data-optimistic-variant-id="' + variantId + '"][data-line-unit-price="0"]').forEach(function (row) {
      if (row.classList.contains('cart-item--bogo-free')) return;
      row.classList.add('cart-item--bogo-free');
      var price = row.querySelector('.cart-item__final-price');
      if (price) price.textContent = 'FREE';
      var title = row.querySelector('.cart-item__name');
      if (title) {
        var badge = document.createElement('p');
        badge.className = 'dt-retention-cart-badge dt-bogo-cart-badge';
        badge.textContent = BADGE_LABEL;
        title.after(badge);
      }
    });
  }

  function addFreeUnitToInstantAdds(controller) {
    if (!controller || typeof controller.add !== 'function') return false;
    if (controller.__dtBogoInstantAdd) return true;
    var originalAdd = controller.add;
    controller.add = function (variantId, quantity, properties, options) {
      var qty = Math.max(1, parseInt(quantity, 10) || 1);
      var opts = options || {};
      var lineProperties = properties || {};
      if (salesOnlyVariantIds.has(String(variantId))) {
        if (!isSalesPageAdd(opts.sourceForm)) return originalAdd.apply(this, arguments);
        lineProperties = Object.assign({}, lineProperties);
        lineProperties[SOURCE_PROPERTY] = 'sale';
      }
      var free = instantFreeUnit(variantId, qty, lineProperties);
      if (!free) return originalAdd.call(this, variantId, quantity, lineProperties, opts);
      var paidItem = opts.optimisticItem || this.getOptimisticItemFromForm(opts.sourceForm, variantId, qty);
      if (paidItem) {
        var unitPrice = Number(paidItem.final_price || paidItem.price || 0);
        free.optimisticItem = Object.assign({}, paidItem, {
          properties: free.properties,
          compare_at_price: unitPrice,
          final_price: 0,
          price: 0,
          final_line_price: 0,
          original_line_price: unitPrice * qty
        });
      }
      var result = originalAdd.call(this, variantId, quantity, lineProperties, Object.assign({}, opts, {
        optimisticItem: paidItem || opts.optimisticItem,
        additionalItems: (opts.additionalItems || []).concat([free])
      }));
      styleInstantFreeRows(variantId);
      return result;
    };
    controller.__dtBogoInstantAdd = true;
    return true;
  }

  // cart-controller.js may load after this script.
  if (!addFreeUnitToInstantAdds(window.CartController)) {
    var hookAttempts = 0;
    var hookTimer = window.setInterval(function () {
      hookAttempts += 1;
      if (addFreeUnitToInstantAdds(window.CartController) || hookAttempts > 40) window.clearInterval(hookTimer);
    }, 250);
  }

  async function reconcileOnce() {
    await syncPendingCartEdits();
    var cart = await readCart();
    var startSignature = cartSignature(cart);
    var offerActive = Date.now() >= inactiveUntil;
    var changes = planChanges(cart, offerActive);
    if (Object.keys(changes.updates).length || changes.additions.length) {
      await applyChanges(changes);
      cart = await readCart();
    }

    if (!freeUnitsArePriced(cart)) {
      inactiveUntil = Date.now() + INACTIVE_RETRY_MS;
      await applyChanges(planChanges(cart, false));
      cart = await readCart();
      console.warn('[BOGO] Free units were not discounted, so they were removed. Check the Buy X Get Y discounts.');
    }

    // Only refresh (and announce cart:updated) when the cart really changed; a failed add
    // that re-announced itself would trigger this function again and loop.
    if (cartSignature(cart) !== startSignature) await refreshCartUi(cart);
    showNotice(stockNotice(cart));
    return cart;
  }

  function reconcile() {
    if (running) {
      rerunRequested = true;
      return running;
    }
    running = reconcileOnce()
      .catch(function (error) {
        console.warn('[BOGO] Unable to update Buy 1 Get 1 items.', error);
      })
      .finally(function () {
        running = null;
        if (rerunRequested) {
          rerunRequested = false;
          reconcile();
        }
      });
    return running;
  }

  window.dtReconcileBogoCart = reconcile;

  document.addEventListener('cart:updated', function () { reconcile(); }, { passive: true });
  document.addEventListener('dt:cart-intent', function () { reconcile(); }, { passive: true });
  document.addEventListener('cart-drawer:opening', function () { reconcile(); }, { passive: true });
  // pubsub.js declares these as top-level globals, not window properties.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { reconcile(); });
  }

  function scheduleInitialReconcile() {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(function () { reconcile(); }, { timeout: 1500 });
    } else {
      window.setTimeout(function () { reconcile(); }, 500);
    }
  }
  scheduleInitialReconcile();
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) scheduleInitialReconcile();
  });
})();
